export default "__VITE_ASSET__DzsFQ7JD__"